<template lang="pug">
    .invoices.margin-left(v-if="hasCustomers")
        vm-row.flex.space-between.gap-0.margin-bottom(vm-w="11.8")
            vm-col(vm-w="1.5")
                .bold {{$t('strings.search_by_customer') + ":"}}
            vm-col(vm-w="4")
                type-ahead-select(:data="invoices.customers" :defaultValue="customer.name" showColumn="name" @item-select="selectCustomer" @search="searchCustomers")
            vm-col(vm-w="2")
                .bold.text-align-right  {{$t('invoices.currency') + ":"}}
            vm-col(vm-w="3.5")
                vm-select(v-model="currency" :defaultValue="currency.code" @change="selectCurrency")
                    vm-select-item(v-for="(item, index) in invoices.currencies" :key="index" :value="item" :text="item.code")
        .invoices(v-if="hasInvoices")
            vm-row.flex.center.gap-0.margin-bottom(vm-w="12")
                vm-col(vm-w="4")
                    card-resize-dashboard(id="card_dashboard_7" :text="customer.name" :title="$t('strings.customer')" :cash="false")
                vm-col(vm-w="4")
                    card-resize-dashboard(id="card_dashboard_8" :amount="invoices.totalHired" :title="$t('strings.total_hired')" currency="" :cash="true")
                vm-col(vm-w="4")
                    card-resize-dashboard(id="card_dashboard_9" :text="currency.code" :title="$t('strings.currency')" :cash="false")
            vm-row.margin-bottom(vm-w="12")
                card-resize-dashboard(id="card_dashboard_10" :currency="currency.code" :amount="invoices.balance" :title="$t('strings.balance')" :large="true")
            vm-row.margin-bottom(vm-w="12")
                .card_dashboard.apexchart_container.flex.gap-1.column.mw-985
                    vm-col(vm-w="12")
                        .bold.margin-left {{$t('strings.payments_vs_invoices')}}
                    bar-chart-dashboard(:series="invoices.barChartData" :categories="invoices.barChartCategories")
            vm-row.card_dashboard.mw-985.margin-bottom.padding(vm-w="12")
                vm-col(vm-w="5.5")
                    vm-row()
                        card-resizeDashboard(id="card_dashboard_12" :cash="true" :currency="currency.code" :amount="invoices.totalInvoiced" :title="$t('strings.invoiced')" :withStyle="false")
                    vm-row.scrollable()
                        table-dashboard(:data="invoices.invoices" :columns="columnsInvoices" :search="false" :pagination="false" :id="true" :orangeText="true" :centerRows="true" :withStyle="false" @clickRow="filter")
                vm-col.flex.center(vm-w="1")
                    .card_separator
                vm-col(vm-w="5.5")
                    vm-row()
                        card-resizeDashboard(id="card_dashboard_11" :cash="true" :currency="currency.code" :amount="invoices.totalPayed" :title="$t('strings.payed')" :withStyle="false")
                    vm-row.scrollable()
                        table-dashboard(:data="invoices.payments" :columns="columnsInvoices" :search="false" :pagination="false" :id="true" :greenText="true" :centerRows="true" :withStyle="false")
        .invoices.margin-left(v-else="!Invoices")
            .flex.center.column.gap-1.container
                .imageNotFound
                h1 {{$t('strings.nothing_to_view')}}
                span {{$t('customers.without_invoices') + currency.currency}}
    .invoices.margin-left(v-else="!hasCustomers")
        .flex.center.column.gap-1.container
            .imageNotFound
            h2 {{$t('strings.nothing_to_view')}}
            span {{$t('strings.without_customers')}}
</template>
<script>
import { createNamespacedHelpers } from 'vuex'

const { mapGetters, mapActions } = createNamespacedHelpers('Dashboard')

const CardResizeDashboard = () => import('@/components/dashboard/CardResizeDashboard.vue')
const TypeAheadSelect = () => import('@/components/aditionals/TypeAheadSelect.vue')
const BarChartDashboard = () => import('@/components/dashboard/BarChartDashboard.vue')
const TableDashboard = () => import('@/components/dashboard/TableDashboard.vue')

export default {
  name: 'InvoicesDashboard',
  components: {
    CardResizeDashboard,
    TypeAheadSelect,
    BarChartDashboard,
    TableDashboard
  },
  data () {
    return {
      customer: {
        id: 1,
        name: ''
      },
      currency: {
        id: 1,
        code: 'MXN',
        currency: 'Peso mexicano'
      },
      hasCustomers: false,
      hasInvoices: false,
      columnsInvoices: [
        'id',
        'date',
        'project',
        'amount'
      ]
    }
  },
  computed: {
    ...mapGetters([
      'invoices'
    ])
  },
  created () {
    this.loadCurrencies()
    this.loadCustomers({ filter: '' }).then(() => {
      if (this.invoices.customers.length) {
        this.hasCustomers = true
        this.customer = {
          id: this.invoices.customers[0]['id'],
          name: this.invoices.customers[0]['name']
        }
        this.loadAllInvoicesData({ customer_id: this.customer.id, currency_id: this.currency.id }).then(() => {
          this.hasInvoices = Boolean(this.invoices.invoices.length)
        })
      }
    })
  },
  methods: {
    ...mapActions([
      'loadCustomers',
      'loadCurrencies',
      'loadAllInvoicesData',
      'filterByInvoiced'
    ]),
    selectCustomer (customer) {
      this.customer = customer
      this.loadAllData()
    },
    searchCustomers (value) {
      this.loadCustomers({ filter: `?param=${value},name` })
    },
    selectCurrency (currency) {
      this.currency = currency
      this.loadAllData()
    },
    filter (row) {
      this.filterByInvoiced(row)
    },
    loadAllData () {
      this.loadAllInvoicesData({ customer_id: this.customer.id, currency_id: this.currency.id }).then(() => {
        this.hasInvoices = Boolean(this.invoices.invoices.length)
      })
    }
  }
}

</script>

<style>

.padding {
    padding: 2rem;
}

.card_separator {
    padding-top: 5%;
    height: 90%;
    width: 1px;
    background-color: BLACK;
    opacity: 0.2;
}

.imageNotFound {
    background-color: transparent;
    height: 400px;
    width: 400px;
    background-image: url('../../assets/not_found.png');
    background-repeat: no-repeat;
    background-size: contain;
}

.container {
    height: 80vh;
}

.scrollable {
    max-height: 300px;
    overflow: auto;
}

</style>
